/*
 * @Author: 刘洪壮 liuhongzhuang@nextmar.com
 * @Date: 2025-06-19 13:34:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-07-08 19:01:59
 * @FilePath: /src/app/payment/components/GlobalPay/AdyenPay/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import {
  adyenPay,
  afterpayPayDetail,
  diffAdyenPay,
  getAdyenDiffPaymentMethods,
  getAdyenPaymentMethods,
  getAdyenVipPaymentMethods,
  vipAdyenPay,
} from '@/api/pay';
import { useReporting } from '@/hooks/useReporting';
import { ProviderType } from '@/reporting';
import logger from '@/utils/client-logger';
import { env } from '@/utils/env';
import AdyenCheckout from '@adyen/adyen-web';
import '@adyen/adyen-web/dist/adyen.css';
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';

interface Props {
  children?: React.ReactNode;
  order: any;
  adyenDomId: string;
  adyenDom3ds: string;
  from?: string;
  paySuccess: () => void;
  payFail: () => void;
}

const AdyenPay = forwardRef(
  (
    { children, order, adyenDomId, adyenDom3ds, from = 'payment', paySuccess, payFail }: Props,
    ref,
  ) => {
    const [checkoutInstance, setCheckoutInstance] = useState<any>(null);
    const { trackEvent } = useReporting();

    // 暴露方法给父组件
    useImperativeHandle(ref, () => ({
      payAction,
    }));

    const [_order, setOrder] = useState<any>(order);
    // 使用ref存储最新的订单数据，确保在回调函数中能获取到最新值
    const orderRef = useRef<any>(order);

    // 当props中的order变化时，同步更新ref
    useEffect(() => {
      orderRef.current = order;
      setOrder(order);
    }, [order]);

    const payAction = async (_o: any) => {
      setOrder(_o);
      // 同时更新ref，确保回调函数中能获取到最新值
      orderRef.current = _o;

      // 直接使用传入的最新订单数据，而不是依赖状态
      const config = await initAdyenConfig(_o);
      const checkoutIns = await AdyenCheckout(config);
      setCheckoutInstance(checkoutIns);
      checkoutIns.create('dropin').mount(adyenDomId);
      autoCheck();
    };

    const initAdyenConfig = async (currentOrder?: any) => {
      // 使用传入的订单数据或当前状态中的订单数据
      const orderToUse = currentOrder || _order;

      let paymentMethods: any = {};
      if (from === 'vip') {
        paymentMethods = await getVipPaymentMethods(orderToUse);
      } else if (from === 'priceDiff') {
        paymentMethods = await getDiffPaymentMethods(orderToUse);
      } else {
        paymentMethods = await getPaymentMethods(orderToUse);
      }

      const adyenConfig = {
        showPayButton: true,
        clientKey: env.NEXT_PUBLIC_AYDEN_CLIENT_KEY,
        environment: env.NEXT_PUBLIC_AYDEN_ENVIROMENT,
        locale: env.NEXT_PUBLIC_FULL_LOCALE.replace('_', '-'), // adyen支付的locale需要是-分隔的，比如en_US需要是en-US
        paymentMethodsResponse: paymentMethods,
        onSubmit,
        onAdditionalDetails,
        handleOnChange,
        paymentMethodsConfiguration: {
          card: {
            enableStoreDetails: true,
            showStoredPaymentMethods: true,
          },
        },
      };
      return adyenConfig;
    };

    const autoCheck = () => {
      setTimeout(() => {
        // adyen勾选框的父级label
        const adyenLabel = document.querySelector(`${adyenDomId} .adyen-checkout__checkbox`);
        // adyen勾选框
        const adyenInput = adyenLabel.querySelector(
          `${adyenDomId} .adyen-checkout__checkbox .adyen-checkout__checkbox__input`,
        );
        if (adyenLabel && adyenInput) {
          // @ts-ignore
          !adyenInput.checked && adyenLabel.click();
        }
      }, 1500);
    };

    const getPaymentMethods = async (orderToUse: any) => {
      const params = {
        order_id: orderToUse.order_id,
      };
      const ret = await getAdyenPaymentMethods(params);
      if (ret.code === 200) {
        return ret.data;
      }
      return [];
    };

    const getVipPaymentMethods = async (orderToUse: any) => {
      const params = {
        vip_order_id: orderToUse.order_id,
      };
      const ret = await getAdyenVipPaymentMethods(params);
      if (ret.code === 200) {
        return ret.data;
      }
      return [];
    };

    const getDiffPaymentMethods = async (orderToUse: any) => {
      const params = {
        diff_order_id: orderToUse.order_id,
      };
      const ret = await getAdyenDiffPaymentMethods(params);
      if (ret.code === 200) {
        return ret.data;
      }
      return [];
    };

    const onSubmit = async (state: any) => {
      // 使用ref中的最新订单数据，而不是状态中的数据
      const currentOrder = orderRef.current;

      if (from === 'vip') {
        const params = {
          vip_order_id: currentOrder.order_id,
          payment_method: JSON.stringify(state.data.paymentMethod),
          payment_type: 'adyen',
          is_bind: state.data.storePaymentMethod ? 1 : 2,
        };
        const ret = await vipAdyenPay(params);
        if (ret && ret.code === 200) {
          paySuccess();
        } else {
          payFail();
        }
      } else if (from === 'priceDiff') {
        const params = {
          diff_order_id: currentOrder.order_id,
          payment_method: JSON.stringify(state.data.paymentMethod),
          payment_type: 'adyen',
          is_bind: state.data.storePaymentMethod ? 1 : 2,
        };
        const ret = await diffAdyenPay(params);
        logger.log(ret);
        if (ret && ret.code === 200) {
          paySuccess();
        } else {
          payFail();
        }
      } else {
        const params = {
          order_id: currentOrder.order_id,
          payment_method: JSON.stringify(state.data.paymentMethod),
          payment_type: 'adyen',
          is_bind: state.data.storePaymentMethod ? 1 : 2,
        };
        const ret: any = await adyenPay(params);
        if (ret && ret.code === 200) {
          trackEvent(
            {
              eventName: 'InitiateCheckout',
            },
            [ProviderType.FACEBOOK],
          );
          if (ret.data.action) {
            has3ds(ret.data);
          } else {
            paySuccess();
          }
        } else {
          payFail();
        }
      }
    };

    const has3ds = (data: any) => {
      if (data.action) {
        // 需要触发 3ds
        const threeDSConfiguration = {
          challengeWindowSize: '02',
        };
        checkoutInstance.createFromAction(data.action, threeDSConfiguration).mount(adyenDom3ds);
      }
    };

    const onAdditionalDetails = async (state: any) => {
      // 使用ref中的最新订单数据
      const currentOrder = orderRef.current;

      const res = await afterpayPayDetail({
        order_id: currentOrder.order_id,
        threeDSResult: state.data.details.threeDSResult,
      });

      if (res && res.code === 200) {
        paySuccess();
      } else {
        payFail();
      }
    };

    const handleOnChange = () => {
      logger.log('@handleOnChange');
    };

    return <div>{children && children}</div>;
  },
);

AdyenPay.displayName = 'AdyenPay';

export default AdyenPay;
